import { render, staticRenderFns } from "./impersonate-card.vue?vue&type=template&id=57d9dd5e"
import script from "./impersonate-card.ts?vue&type=script&lang=ts&external"
export * from "./impersonate-card.ts?vue&type=script&lang=ts&external"
import style0 from "./impersonate-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports